import { render, staticRenderFns } from "./AddressDetails.vue?vue&type=template&id=1f69970a&scoped=true&"
import script from "./AddressDetails.vue?vue&type=script&lang=js&"
export * from "./AddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69970a",
  null
  
)

export default component.exports